import { useRef, useState, type SyntheticEvent } from "react";

/** Folga entre o topo do corpo e o início da seção considerada ativa. */
export const SECOES_SCROLL_TOLERANCE = 24;

/**
 * Menu de seções e corpo rolável: escolher rola até a seção; rolar marca a seção em leitura. A escolhida fica ativa
 * até o usuário rolar, pois a animação do scroll passa por outras seções e, no fim do corpo, a última venceria.
 */
export function useSecoesScroll(initialId: string) {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [activeId, setActiveId] = useState(initialId);
  const pinnedRef = useRef(false);

  function selecionar(id: string) {
    setActiveId(id);

    const body = bodyRef.current;
    const section = body?.querySelector<HTMLElement>(`[data-section-id="${id}"]`);
    if (!body || !section) return;

    pinnedRef.current = true;
    body.scrollTop = Math.min(section.offsetTop, body.scrollHeight - body.clientHeight);
  }

  // O overlay do seletor mobile é um portal: seus eventos sobem pela árvore React, mas não são do corpo.
  function aoInteragir(event: SyntheticEvent) {
    if (bodyRef.current?.contains(event.target as Node)) pinnedRef.current = false;
  }

  function aoRolar() {
    const body = bodyRef.current;
    if (!body) return;

    if (pinnedRef.current) return;

    const elements = Array.from(body.querySelectorAll<HTMLElement>("[data-section-id]"));
    const limit = body.scrollTop + SECOES_SCROLL_TOLERANCE;
    // Seção final curta nunca alcança o topo: no fim da rolagem, a última é a ativa.
    const noFim =
      body.scrollHeight > body.clientHeight &&
      body.scrollTop + body.clientHeight >= body.scrollHeight - 1;
    const current = noFim
      ? elements.at(-1)
      : (elements.filter((element) => element.offsetTop <= limit).at(-1) ?? elements[0]);
    if (current?.dataset.sectionId) setActiveId(current.dataset.sectionId);
  }

  const propsCorpo = {
    onScroll: aoRolar,
    onWheel: aoInteragir,
    onTouchStart: aoInteragir,
    onKeyDown: aoInteragir,
    onPointerDown: aoInteragir,
  };

  return { bodyRef, activeId, selecionar, propsCorpo };
}
